import { render, staticRenderFns } from "./ViewMethodScreening.vue?vue&type=template&id=09202981&scoped=true"
import script from "./ViewMethodScreening.vue?vue&type=script&lang=js"
export * from "./ViewMethodScreening.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09202981",
  null
  
)

export default component.exports